<div class="page">
  <app-page-header itemName="{{ intervention.get('name') }}" page-title="interventions.detail.pageTitle">
  </app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <mat-card-title>{{ 'interventions.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <app-creator-updator-box [data]="intervention"></app-creator-updator-box>

          <div class="row h6 mt-4 text-muted font-weight-normal" *ngIf="intervention">
            <div class="col-12">
              <mat-chip-list class="d-block py-2">
                <div *ngIf="intervention.status === 'open'">
                  <mat-chip selected class="chip-green" matTooltip="{{ 'interventions.status.tooltip' | translate }}">
                    {{ 'interventions.status.open' | translate }}
                  </mat-chip>
                  <button mat-stroked-button matTooltip="{{ 'interventions.status.moveToClosedTooltip' | translate }}"
                    (click)="onStatusChange()">
                    {{ 'interventions.status.moveToClosed' | translate }}
                  </button>
                </div>
                <div *ngIf="intervention.status === 'closed'">
                  <mat-chip selected class="chip-red" matTooltip="{{ 'interventions.status.tooltip' | translate }}">
                    {{ 'interventions.status.closed' | translate }}
                  </mat-chip>
                </div>
              </mat-chip-list>
            </div>
          </div>

          <div class="form-wrapper">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate mt-2">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-12">
          <mat-card-title>{{ 'interventions.fields.contractors' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <button class="mb-4" mat-raised-button color="primary" (click)="onAddContractor()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateInterventions')"
            matTooltip="{{ 'interventions.contractors.add.tooltip' | translate }}">
            <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>

          <ng-container>
            <app-card-spinner [visible]="contractorsCardIsLoading" type="zero"></app-card-spinner>
            <div class="alert alert-warning d-none my-3" role="alert"
              [ngClass]="{ 'd-block': !intervention.get('contractors') || (intervention.get('contractors') && !intervention.get('contractors').length)}">
              {{ 'common.words.display_no_data' | translate }}
            </div>
            <table class="table table-borderless table-striped" matSort matSortActive="name" matSortDirection="desc"
              (matSortChange)="sortContractorsData($event)" matSortDisableClear>
              <thead>
                <th>#</th>
                <th class="clickable" mat-sort-header="name">
                  {{ 'interventions.contractors.list.name' | translate }}</th>
                <th class="clickable" mat-sort-header="fee">
                  {{ 'interventions.contractors.list.fee' | translate }}
                </th>
                <th>{{ 'common.cta.actions' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of sortedContractorsData; let i = index">
                  <th style="width: 3%">{{ i + 1 }}</th>
                  <td>{{ item.name }}</td>
                  <td>{{ item.fee }}</td>
                  <td>
                    <button (click)="onEditContractor(item)" mat-raised-button color="primary"
                      matTooltip="{{ 'interventions.contractors.detail.tooltip' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-12">
          <mat-card-title>{{ 'interventions.fields.taxDeductionFees' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <button class="mb-4" mat-raised-button color="primary" (click)="onAddTaxDeductionFee()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateInterventions')"
            matTooltip="{{ 'interventions.taxDeductionFees.add.tooltip' | translate }}">
            <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>

          <ng-container>
            <app-card-spinner [visible]="taxDeductionFeesCardIsLoading" type="zero"></app-card-spinner>
            <div class="alert alert-warning d-none my-3" role="alert"
              [ngClass]="{ 'd-block': !intervention.get('taxDeductionFees') || (intervention.get('taxDeductionFees') && !intervention.get('taxDeductionFees').length)}">
              {{ 'common.words.display_no_data' | translate }}
            </div>
            <table class="table table-borderless table-striped" matSort matSortActive="year" matSortDirection="desc"
              (matSortChange)="sortTaxDeductionFeesData($event)" matSortDisableClear>
              <thead>
                <th>#</th>
                <th class="clickable" mat-sort-header="year">
                  {{ 'interventions.taxDeductionFees.list.year' | translate }}</th>
                <th class="clickable" mat-sort-header="fee">
                  {{ 'interventions.taxDeductionFees.list.fee' | translate }}
                </th>
                <th class="clickable" mat-sort-header="resolved">
                  {{ 'interventions.taxDeductionFees.list.resolved' | translate }}
                </th>
                <th>{{ 'common.cta.actions' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of sortedTaxDeductionFeesData; let i = index">
                  <th style="width: 3%">{{ i + 1 }}</th>
                  <td>{{ item.year }}</td>
                  <td>{{ item.fee }}</td>
                  <td>
                    <mat-checkbox class="checkbox-insert" [checked]="item.resolved"
                      (change)="onToggleTaxDeductionFee(item._id, $event.checked)">
                    </mat-checkbox>
                  </td>
                  <td>
                    <button (click)="onEditTaxDeductionFee(item)" mat-raised-button color="primary"
                      matTooltip="{{ 'interventions.taxDeductionFees.detail.tooltip' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-12">
          <mat-card-title>{{ 'interventions.fields.receivedDocuments' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <button class="mb-4" mat-raised-button color="primary" (click)="onAddReceivedDocument()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateInterventions')"
            matTooltip="{{ 'interventions.receivedDocuments.add.tooltip' | translate }}">
            <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>

          <ng-container>
            <app-card-spinner [visible]="receivedDocumentsCardIsLoading" type="zero"></app-card-spinner>
            <div class="alert alert-warning d-none my-3" role="alert"
              [ngClass]="{ 'd-block': !intervention.get('receivedDocuments') || (intervention.get('receivedDocuments') && !intervention.get('receivedDocuments').length)}">
              {{ 'common.words.display_no_data' | translate }}
            </div>
            <table class="table table-borderless table-striped" matSort matSortActive="name" matSortDirection="desc"
              (matSortChange)="sortReceivedDocumentsData($event)" matSortDisableClear>
              <thead>
                <th>#</th>
                <th class="clickable" mat-sort-header="name">
                  {{ 'interventions.receivedDocuments.list.name' | translate }}</th>
                <th class="clickable" mat-sort-header="description">
                  {{ 'interventions.receivedDocuments.list.description' | translate }}
                </th>
                <th class="clickable" mat-sort-header="received">
                  {{ 'interventions.receivedDocuments.list.received' | translate }}
                </th>
                <th>{{ 'common.cta.actions' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of sortedReceivedDocumentsData; let i = index">
                  <th style="width: 3%">{{ i + 1 }}</th>
                  <td>{{ item.name }}</td>
                  <td class="description-field">{{ item.description }}</td>
                  <td>
                    <mat-checkbox class="checkbox-insert" [checked]="item.received"
                      (change)="onToggleReceivedDocument(item._id, $event.checked)">
                    </mat-checkbox>
                  </td>
                  <td>
                    <button (click)="onEditReceivedDocument(item)" mat-raised-button color="primary"
                      matTooltip="{{ 'interventions.receivedDocuments.detail.tooltip' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->